import React, { Component } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { FeatureShowcase } from './components/FeatureShowcase';
import { Features as FeaturesComponent } from './components/Features';
import { Metrics } from './components/Metrics';
import { GetStarted } from './components/GetStarted';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { Dashboard } from './pages/Dashboard';
import { PrepCentre } from './pages/PrepCentre';
import { Settings } from './pages/Settings';
import { Pricing } from './pages/Pricing';
import { Features } from './pages/Features';
import { About } from './pages/About';
import { Home } from './pages/Home';
import { Privacy } from './pages/Privacy';
import { Signup } from './pages/Signup';
import { Login } from './pages/Login';
import { Authentication } from './pages/Authentication';
import { GooglePlugin } from './pages/GooglePlugin';
import { Onboarding } from './pages/Onboarding';
import { SlackMessage } from './pages/SlackMessage';
import { Prompts } from './pages/Prompts';
import { Construction } from './pages/Construction';
import { Design } from './pages/Design';
import { Simulation } from './pages/Simulation';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Construction data-id="element-3" />} data-id="element-2" />
        <Route path="/home" element={<Home data-id="element-5" />} data-id="element-4" />
        <Route path="/dashboard" element={<Dashboard data-id="element-7" />} data-id="element-6" />
        <Route path="/prepcentre" element={<PrepCentre data-id="element-9" />} data-id="element-8" />
        <Route path="/settings" element={<Settings data-id="element-11" />} data-id="element-10" />
        <Route path="/pricing" element={<Pricing data-id="element-13" />} data-id="element-12" />
        <Route path="/features" element={<Features data-id="element-15" />} data-id="element-14" />
        <Route path="/about" element={<About data-id="element-17" />} data-id="element-16" />
        <Route path="/privacy" element={<Privacy data-id="element-19" />} data-id="element-18" />
        <Route path="/signup" element={<Signup data-id="element-21" />} data-id="element-20" />
        <Route path="/login" element={<Login data-id="element-23" />} data-id="element-22" />
        <Route path="/authentication" element={<Authentication data-id="element-25" />} data-id="element-24" />
        <Route path="/googleplugin" element={<GooglePlugin data-id="element-27" />} data-id="element-26" />
        <Route path="/onboarding" element={<Onboarding data-id="element-29" />} data-id="element-28" />
        <Route path="/slackmessage" element={<SlackMessage data-id="element-31" />} data-id="element-30" />
        <Route path="/prompts" element={<Prompts data-id="element-33" />} data-id="element-32" />
        <Route path="/construction" element={<Construction data-id="element-35" />} data-id="element-34" />
        <Route path="/design" element={<Design data-id="element-37" />} data-id="element-36" />
        <Route path="/simulation" element={<Simulation data-id="element-39" />} data-id="element-38" />
      </Routes>
    </BrowserRouter>;
}